import { Base } from '../../../../.generated/Foundation.GMI.model';
import { CtaContentResultAnalyticsConfig } from 'components/helpers/Analytics/Cta/CtaAnalytics';
import { useLinkWrapper } from 'components/helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import { CtaComponentClass } from 'lib/hooks/theming/useCtaComponentClass';
import { CtaFields } from 'lib/types/headlineFields';
import { CtaPropsClass, CtaPropsVariant, CtaStyle, CtaVariant } from './CtaButton';

interface CtaFieldsSitecoreProps {
  fields: Base.ComponentFields.CtaFields.Cta1Field['fields'] &
    Base.ComponentFields.CtaFields.Cta2Field['fields'];
  ctaComponentClassOverrides?: {
    cta1: CtaComponentClass;
    cta2: CtaComponentClass;
  };
  ctaStyleOverrides?: {
    cta1: CtaStyle;
    cta2: CtaStyle;
  };
  ctaVariantOverrides?: {
    cta1: CtaVariant;
    cta2: CtaVariant;
  };
  contentResultAnalytics?: CtaContentResultAnalyticsConfig;
}

export function useCtaFields({
  fields,
  ctaComponentClassOverrides,
  ctaStyleOverrides,
  ctaVariantOverrides,
  contentResultAnalytics,
}: CtaFieldsSitecoreProps): CtaFields {
  const cta1ComponentClass =
    ctaComponentClassOverrides?.cta1 || 'component-content-grid-color-button-color-1';
  const cta2ComponentClass =
    ctaComponentClassOverrides?.cta2 || 'component-content-grid-color-button-color-2';

  const ctaVariant1Props: CtaPropsVariant | CtaPropsClass = ctaVariantOverrides?.cta1
    ? {
        ctaVariant: ctaVariantOverrides?.cta1,
        ctaStyle: ctaStyleOverrides?.cta1 || 'filled',
      }
    : {
        ctaComponentClass: cta1ComponentClass,
        ctaStyle: ctaStyleOverrides?.cta1 || 'filled',
      };

  const ctaVariant2Props: CtaPropsVariant | CtaPropsClass = ctaVariantOverrides?.cta2
    ? {
        ctaVariant: ctaVariantOverrides?.cta2,
        ctaStyle: ctaStyleOverrides?.cta2 || 'outline',
      }
    : {
        ctaComponentClass: cta2ComponentClass,
        ctaStyle: ctaStyleOverrides?.cta2 || 'outline',
      };

  const cta1 = useLinkWrapper({
    field: fields?.cta1,
    contentResultAnalytics,
    ...ctaVariant1Props,
  });
  const cta2 = useLinkWrapper({
    field: fields?.cta2,
    contentResultAnalytics,
    ...ctaVariant2Props,
  });

  return {
    cta1,
    cta2,
  };
}
